/** A Settings row: label and hint on the left, its control on the right (Settings, the reminders sheet). */
import type { ReactNode } from 'react';
import s from '../screens/SettingsScreen.module.css';

export function Row({ label, hint, htmlFor, children }: { label: string; hint?: string; htmlFor?: string; children: ReactNode }) {
  return (
    <div className={s.row}>
      <div className={s.rowText}>
        {htmlFor ? (
          <label htmlFor={htmlFor} className={s.rowLabel}>
            {label}
          </label>
        ) : (
          <span className={s.rowLabel}>{label}</span>
        )}
        {hint && <span className={s.rowHint}>{hint}</span>}
      </div>
      <div className={s.rowControl}>{children}</div>
    </div>
  );
}
